const SMARTLING_LOCALES = {
  ar: { name: 'Arabic' },
  'de-DE': { name: 'German' },
  'en-US': { name: 'English' },
  'es-ES': { name: 'Spanish' },
  'es-LA': { name: 'Latin American Spanish' },
  'fi-FI': { name: 'Finnish' },
  'fr-CA': { name: 'Québécois' },
  'fr-FR': { name: 'French' },
  'he-IL': { name: 'Hebrew' },
  'hu-HU': { name: 'Hungarian' },
  'id-ID': { name: 'Indonesian' },
  'it-IT': { name: 'Italian' },
  'ja-JP': { name: 'Japanese' },
  'ko-KR': { name: 'Korean' },
  'nl-NL': { name: 'Dutch' },
  'pl-PL': { name: 'Polish' },
  'pt-BR': { name: 'Brazilian Portuguese' },
  'ru-RU': { name: 'Russian' },
  'sv-SE': { name: 'Swedish' },
  'th-TH': { name: 'Thai' },
  'tr-TR': { name: 'Turkish' },
  'vi-VN': { name: 'Vietnamese' },
  'zh-TW': { name: 'Traditional Chinese' },
};

module.exports = {
  SMARTLING_LOCALES,
  DEFAULT_LOCALE: 'en-US',
};
